<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="近接工事申請件名詳細"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll>
          <template #left>
            <proximity-info
              :isEdit="false"
              :requestHeaderId="requestHeaderId"
              @update:form="detail = $event"
              :returnToList="true"
              :isActionBtnVisible="true"
              :isHistoryTableVisible="true"
            />
          </template>
          <template #right>
            <el-collapse class="right-panels double-scroll-padding" v-if="detail != null">
              <!-- 要否判定 -->
              <input-group-dark title="要否判定" class="judge_discussion">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses
                      v-model="detail.proximity.judge_discussion_status"
                      :statuses="judgeDiscussion"
                      class="judge_discussion_status"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="要否判定詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_JD_ASK,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>協議要否判断伺い</jr-button-for-jrqc>
                    </router-link>
                    <router-link :to="{ name: 'ProximityJudge' }">
                      <jr-button-for-jr>要否判断</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_JD_UNNECESSARY_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>不要連絡</jr-button-for-jr>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_JUDGE_DISCUSSION"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
              <!-- 事前協議 -->
              <input-group-dark title="事前協議" class="prior_discussion">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses
                      v-model="detail.proximity.prior_discussion_status"
                      :statuses="priorDiscussion"
                      class="prior_discussion_status"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="実施日">
                    <span v-if="detail.proximity.prior_discussion_date == null" class="text-xs prior_discussion_date"
                      >未定</span
                    >
                    <date-display
                      v-else
                      :date="detail.proximity.prior_discussion_date"
                      type="date"
                      size="small"
                      class="prior_discussion_date"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="事前協議内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'ScheduleMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_PD_ADJUST_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jr>日程調整</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ScheduleDecide',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_PD_DECIDE_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_PD_DECIDE_DATE_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定連絡</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'PreDiscussionEdit',
                        params: {
                          request_header_id: detail.request_header_id,
                        },
                      }"
                    >
                      <jr-button-for-jr>結果入力</jr-button-for-jr>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_PRIOR_DISCUSSION"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
              <!-- 協議書 -->
              <input-group-dark title="協議書" class="discussion_document">
                <el-descriptions :column="2" border size="small">
                  <el-descriptions-item label="状態" :span="2">
                    <statuses v-model="detail.proximity.discussion_document_status" :statuses="discussionDocument" />
                  </el-descriptions-item>
                  <el-descriptions-item label="協議書" :span="2">
                    <!-- ファイル -->
                    <el-row>
                      <el-col :span="22" class="discussion_document_file">
                        <upload-proximity-file
                          v-model="detail.proximity.discussion_document_file"
                          :fileType="FileTypes.PROXIMITY_DISCUSSION_DOCUMENT"
                          :applicant="false"
                          :proximityId="detail.proximity.proximity_id"
                          @uploaded="discussionDocumentHistoryKey++"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                  <el-descriptions-item label="受付" :span="2">
                    <span
                      v-if="detail.proximity.discussion_document_receipt_number == null"
                      class="text-xs discussion_document_receipt_number"
                    >
                      未発行
                    </span>
                    <span v-else class="text-xs discussion_document_receipt_number"
                      >{{ detail.proximity.discussion_document_receipt_number }}
                    </span>
                  </el-descriptions-item>
                </el-descriptions>

                <el-collapse-item title="協議書内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_DD_REQUEST,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>協議書作成依頼</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_DD_RECEIPT,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>協議書受理</jr-button-for-jr>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :key="discussionDocumentHistoryKey"
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_DISCUSSION_DOCUMENT"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
              <!-- 現地立会 -->
              <input-group-dark title="現地立会" class="witness">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses v-model="detail.proximity.witness_status" :statuses="witness" />
                  </el-descriptions-item>
                  <el-descriptions-item label="実施日">
                    <span v-if="detail.proximity.witness_date == null" class="text-xs witness_date">未定</span>
                    <date-display
                      v-else
                      :date="detail.proximity.witness_date"
                      type="date"
                      size="small"
                      class="witness_date"
                    />
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="現地立会内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'JrScheduleMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_JR_ADJUST_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jr>JR関係者日程調整</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ScheduleMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_ADJUST_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>協議先日程調整</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'ScheduleDecide',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_DECIDE_DATE,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_DECIDE_DATE_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>日程確定連絡</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_JR_DECIDE_DATE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>JR日程確定連絡</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'OnSiteEdit',
                        params: {
                          request_header_id: detail.request_header_id,
                        },
                      }"
                    >
                      <jr-button-for-jr>結果入力</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'OpinionInquiry',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_WS_OPINION,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>意見照会</jr-button-for-jrqc>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_WITNESS"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
              <!-- 回答 -->
              <input-group-dark title="回答" class="answer">
                <el-descriptions :column="2" border size="small">
                  <el-descriptions-item label="状態" :span="2">
                    <statuses v-model="detail.proximity.answer_status" :statuses="answer" />
                  </el-descriptions-item>
                  <el-descriptions-item label="回答案" :span="2">
                    <!-- ファイル -->
                    <el-row>
                      <el-col :span="22" class="answer_draft_file">
                        <upload-proximity-file
                          v-model="detail.proximity.answer_draft_file"
                          :fileType="FileTypes.PROXIMITY_ANSWER_DRAFT"
                          :applicant="false"
                          :proximityId="detail.proximity.proximity_id"
                          @uploaded="answerHistoryKey++"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                  <el-descriptions-item label="回答書" :span="2">
                    <!-- ファイル -->
                    <el-row>
                      <el-col :span="22" class="answer_file">
                        <upload-proximity-file
                          v-model="detail.proximity.answer_file"
                          :fileType="FileTypes.PROXIMITY_ANSWER"
                          :applicant="false"
                          :proximityId="detail.proximity.proximity_id"
                          @uploaded="answerHistoryKey++"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                  <el-descriptions-item label="回答請書" :span="2">
                    <!-- ファイル -->
                    <el-row>
                      <el-col :span="22" class="answer_confirmation_file">
                        <upload-proximity-file
                          v-model="detail.proximity.answer_confirmation_file"
                          :fileType="FileTypes.PROXIMITY_ANSWER_CONFIRMATION"
                          :applicant="false"
                          :proximityId="detail.proximity.proximity_id"
                          @uploaded="answerHistoryKey++"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>

                <el-collapse-item title="回答内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'ProximityAnswer',
                        params: {
                          request_header_id: detail.request_header_id,
                        },
                      }"
                    >
                      <jr-button-for-jrqc>回答案作成</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AS_ASK,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>回答案伺</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AS_PRE_EXPLAIN,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>回答案送付(事前説明)</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AS_ANSWER,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>回答書送付</jr-button-for-jr>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AS_RECEIPT_NOTICE,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>回答請書受理</jr-button-for-jr>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :key="answerHistoryKey"
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_ANSWER"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
              <!-- 覚書等 -->
              <input-group-dark title="覚書等" class="adversaria">
                <el-descriptions :column="1" border size="small">
                  <el-descriptions-item label="状態">
                    <statuses v-model="detail.proximity.adversaria_status" :statuses="adversaria" />
                  </el-descriptions-item>
                  <el-descriptions-item label="覚書">
                    <!-- ファイル -->
                    <el-row>
                      <el-col :span="22" class="adversaria_file">
                        <upload-proximity-file
                          v-model="detail.proximity.adversaria_file"
                          :fileType="FileTypes.PROXIMITY_ADVERSARIA"
                          :applicant="false"
                          :proximityId="detail.proximity.proximity_id"
                          @uploaded="adversariaHistoryKey++"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                  <el-descriptions-item label="その他">
                    <el-row>
                      <el-col :span="22" class="general_attached_file">
                        <general-attached-files
                          v-model="detail.general_attached_file"
                          ref="generalAttachedFilesRef"
                          :isEdit="true"
                          :isJrExts="true"
                          :immediateUpload="true"
                          size="small"
                          @update:modelValue="detail.general_attached_file"
                          @updatedFile="updateGeneralAttachedFile($event)"
                          @deletedFileId="deleteGeneralAttachedFile($event)"
                        />
                      </el-col>
                    </el-row>
                  </el-descriptions-item>
                </el-descriptions>
                <el-collapse-item title="覚書等内容詳細">
                  <div class="action-buttons flex text-xs">
                    <router-link
                      :to="{
                        name: 'NormalMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AD_REQUEST,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jrqc>覚書等作成依頼</jr-button-for-jrqc>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'GeneralAttachedMessageSend',
                        params: {
                          request_header_id: detail.request_header_id,
                          message_type: MessageTypes.P_AD_UPLOAD_WITH_MSG,
                          action: 'send',
                        },
                      }"
                    >
                      <jr-button-for-jr>覚書等送付</jr-button-for-jr>
                    </router-link>
                  </div>
                  <Suspense>
                    <message-history
                      :key="adversariaHistoryKey"
                      :requestHeaderId="detail.request_header_id"
                      :messageGroup="MessageGroups.P_ADVERSARIA"
                    />
                  </Suspense>
                </el-collapse-item>
              </input-group-dark>
            </el-collapse>
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import Statuses from '@/components/others/Statuses.vue'
import MessageHistory from '@/components/others/MessageHistory.vue'
import JrButtonForJr from '@/components/jr-parts/JrButtonForJr.vue'
import JrButtonForJrqc from '@/components/jr-parts/JrButtonForJrqc.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import UploadProximityFile from '@/components/inputs/UploadProximityFile.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'
import GeneralAttachedFiles from '@/components/inputs/GeneralAttachedFiles.vue'

import { judgeDiscussion, priorDiscussion, discussionDocument, witness, answer, adversaria } from '@/constants/statuses'
import { useRoute } from 'vue-router'
import { RequestHeaderProximityForm } from '@/types/forms'
import { MessageGroups } from '@/constants/messageGroups'
import { MessageTypes } from '@/constants/messageTypes'
import { FileTypes, JR_UPLOAD_FILE_EXTS } from '@/constants/enums'
import {
  CreateGeneralAttachedFileApiRequest,
  DeleteGeneralAttachedFileApiRequest,
} from '@/requests/GeneralAttachedFile'
import { GeneralAttachedFilePost, GeneralAttachedFile } from '@/api'

/**
 * 近接工事申請件名詳細
 */
export default defineComponent({
  name: 'ProximityDetail',
  components: {
    InputGroupDark,
    DoubleScroll,
    Statuses,
    MessageHistory,
    JrButtonForJr,
    JrButtonForJrqc,
    UserLoginWrapper,
    ProximityInfo,
    DateDisplay,
    UploadProximityFile,
    JrApplicantTitle,
    GeneralAttachedFiles,
  },
  setup() {
    const route = useRoute()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    const detail = ref<RequestHeaderProximityForm | null>(null)
    // 回答履歴の更新用key
    const answerHistoryKey = ref<number>(0)
    // 覚書履歴の更新用key
    const adversariaHistoryKey = ref<number>(0)
    // 協議書履歴の更新用key
    const discussionDocumentHistoryKey = ref<number>(0)
    // 覚書・その他
    const generalAttachedFilesRef = ref<InstanceType<typeof GeneralAttachedFiles>>()

    // 覚書・その他 汎用添付ファイルを追加更新
    const updateGeneralAttachedFile = async (fileId: number) => {
      // requestの作成
      const GeneralAttachedFilePost: GeneralAttachedFilePost = {
        request_header: requestHeaderId.value,
        file: fileId,
      }
      const request = new CreateGeneralAttachedFileApiRequest(GeneralAttachedFilePost)
      // API実行
      await request.exec()
    }

    // 覚書・その他 汎用添付ファイルを削除更新
    const deleteGeneralAttachedFile = async (fileId: number) => {
      // requestの作成
      const GeneralAttachedFile: GeneralAttachedFile = {
        file: fileId,
      }
      const request = new DeleteGeneralAttachedFileApiRequest(GeneralAttachedFile)
      // API実行
      await request.exec()
    }

    return {
      requestHeaderId,
      judgeDiscussion,
      priorDiscussion,
      discussionDocument,
      witness,
      answer,
      adversaria,
      detail,
      MessageGroups,
      MessageTypes,
      FileTypes,
      answerHistoryKey,
      adversariaHistoryKey,
      discussionDocumentHistoryKey,
      allowExts: JR_UPLOAD_FILE_EXTS,
      generalAttachedFilesRef,
      updateGeneralAttachedFile,
      deleteGeneralAttachedFile,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-collapse {
  border-top: none;
  border-bottom: none;
}
.el-collapse-item {
  ::v-deep(.el-collapse-item__content) {
    padding-bottom: 0px !important;
  }
  ::v-deep(.el-collapse-item__wrap) {
    border-top: none !important;
    border-bottom: none !important;
  }
  ::v-deep(.el-collapse-item__header) {
    border-top: none !important;
    border-bottom: none !important;
  }
}
.action-buttons {
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: -5px;
  padding-bottom: 10px;
  .el-button {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
  }
}
.input-group-dark {
  margin-top: 8px;
  margin-bottom: 8px;
}
.right-panels {
  margin-top: -8px;
  margin-bottom: -8px;
}

.el-descriptions {
  ::v-deep(.el-descriptions__label) {
    width: 90px;
  }
}
</style>
